import { createSlice } from "@reduxjs/toolkit";
import {
  getGruposThunk,
  getGrupoDetailThunk,
  syncGrupoPermisosThunk,
  getPermisosDisponiblesThunk,
  getUsuariosPermisosThunk,
  getUsuarioPermisoDetailThunk,
  syncUsuarioGruposThunk,
  syncUsuarioPermisosEspecialesThunk,
} from "./rolesPermisos.thunks";

const initialState = {
  // Grupos
  grupos: [],
  grupoDetail: null,
  gruposLoading: false,
  grupoDetailLoading: false,
  syncGrupoLoading: false,

  // Permisos disponibles (agrupados por app)
  permisosDisponibles: [],
  permisosLoading: false,

  // Usuarios
  usuarios: [],
  usuarioDetail: null,
  usuariosLoading: false,
  usuarioDetailLoading: false,
  syncUsuarioLoading: false,

  error: null,
};

const rolesPermisosSlice = createSlice({
  name: "rolesPermisos",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearGrupoDetail: (state) => {
      state.grupoDetail = null;
    },
    clearUsuarioDetail: (state) => {
      state.usuarioDetail = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // getGrupos
      .addCase(getGruposThunk.pending, (state) => {
        state.gruposLoading = true;
        state.error = null;
      })
      .addCase(getGruposThunk.fulfilled, (state, action) => {
        state.gruposLoading = false;
        state.grupos = action.payload;
      })
      .addCase(getGruposThunk.rejected, (state, action) => {
        state.gruposLoading = false;
        state.error = action.payload;
      })

      // getGrupoDetail
      .addCase(getGrupoDetailThunk.pending, (state) => {
        state.grupoDetailLoading = true;
        state.error = null;
      })
      .addCase(getGrupoDetailThunk.fulfilled, (state, action) => {
        state.grupoDetailLoading = false;
        state.grupoDetail = action.payload;
      })
      .addCase(getGrupoDetailThunk.rejected, (state, action) => {
        state.grupoDetailLoading = false;
        state.error = action.payload;
      })

      // syncGrupoPermisos
      .addCase(syncGrupoPermisosThunk.pending, (state) => {
        state.syncGrupoLoading = true;
        state.error = null;
      })
      .addCase(syncGrupoPermisosThunk.fulfilled, (state, action) => {
        state.syncGrupoLoading = false;
        state.grupoDetail = action.payload;
        // Update count in list
        const idx = state.grupos.findIndex((g) => g.id === action.payload.id);
        if (idx !== -1) {
          state.grupos[idx].total_permisos = (action.payload.permissions ?? []).length;
        }
      })
      .addCase(syncGrupoPermisosThunk.rejected, (state, action) => {
        state.syncGrupoLoading = false;
        state.error = action.payload;
      })

      // getPermisosDisponibles
      .addCase(getPermisosDisponiblesThunk.pending, (state) => {
        state.permisosLoading = true;
        state.error = null;
      })
      .addCase(getPermisosDisponiblesThunk.fulfilled, (state, action) => {
        state.permisosLoading = false;
        state.permisosDisponibles = action.payload;
      })
      .addCase(getPermisosDisponiblesThunk.rejected, (state, action) => {
        state.permisosLoading = false;
        state.error = action.payload;
      })

      // getUsuarios
      .addCase(getUsuariosPermisosThunk.pending, (state) => {
        state.usuariosLoading = true;
        state.error = null;
      })
      .addCase(getUsuariosPermisosThunk.fulfilled, (state, action) => {
        state.usuariosLoading = false;
        state.usuarios = action.payload;
      })
      .addCase(getUsuariosPermisosThunk.rejected, (state, action) => {
        state.usuariosLoading = false;
        state.error = action.payload;
      })

      // getUsuarioDetail
      .addCase(getUsuarioPermisoDetailThunk.pending, (state) => {
        state.usuarioDetailLoading = true;
        state.error = null;
      })
      .addCase(getUsuarioPermisoDetailThunk.fulfilled, (state, action) => {
        state.usuarioDetailLoading = false;
        state.usuarioDetail = action.payload;
      })
      .addCase(getUsuarioPermisoDetailThunk.rejected, (state, action) => {
        state.usuarioDetailLoading = false;
        state.error = action.payload;
      })

      // syncUsuarioGrupos
      .addCase(syncUsuarioGruposThunk.pending, (state) => {
        state.syncUsuarioLoading = true;
        state.error = null;
      })
      .addCase(syncUsuarioGruposThunk.fulfilled, (state, action) => {
        state.syncUsuarioLoading = false;
        state.usuarioDetail = action.payload;
      })
      .addCase(syncUsuarioGruposThunk.rejected, (state, action) => {
        state.syncUsuarioLoading = false;
        state.error = action.payload;
      })

      // syncUsuarioPermisosEspeciales
      .addCase(syncUsuarioPermisosEspecialesThunk.pending, (state) => {
        state.syncUsuarioLoading = true;
        state.error = null;
      })
      .addCase(syncUsuarioPermisosEspecialesThunk.fulfilled, (state, action) => {
        state.syncUsuarioLoading = false;
        state.usuarioDetail = action.payload;
      })
      .addCase(syncUsuarioPermisosEspecialesThunk.rejected, (state, action) => {
        state.syncUsuarioLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearGrupoDetail, clearUsuarioDetail } =
  rolesPermisosSlice.actions;

export default rolesPermisosSlice.reducer;
